import { render, staticRenderFns } from "./categories-item.vue?vue&type=template&id=5784add6&scoped=true&"
import script from "./categories-item.vue?vue&type=script&lang=js&"
export * from "./categories-item.vue?vue&type=script&lang=js&"
import style0 from "./categories-item.vue?vue&type=style&index=0&id=5784add6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5784add6",
  null
  
)

export default component.exports